module.exports = __webpack_public_path__ + "img/1504139291.19f13238.jpg";